<form [formGroup]="dropdownForm">
    @if (showDropdownMenu) {
        <div class="background" (click)="toggleDropdown()"></div>
    }
    <div
        class="dropdown"
        [ngClass]="{
            disabled: dropdownDisabled(),
            'readonly-input-control': isReadonlyInputControl,
        }"
        paceCoreValidationMessage
        [validation]="dropdownForm"
    >
        <div class="input-group">
            @if (!model.options.displayText) {
                <div
                    class="form-control flex-grow-1 dropdown-display"
                    #dropDownButton
                    (click)="toggleDropdownFromMenu($event)"
                    [ngClass]="{ 'is-invalid': !dropdownForm.valid }"
                >
                    {{ model.selectedEntry ? model.selectedEntry.displayName : strings.placeholder }}
                </div>
            }
            @if (model.options.displayText) {
                <input
                    class="form-control input-md text-input"
                    type="text"
                    formControlName="dropdownTextInputControl"
                    [placeholder]="model.options.placeholder"
                    (click)="toggleDropdownFromMenu($event)"
                    (input)="clearDropdownSelection($event)"
                    [ngClass]="{
                        'ng-invalid': dropdownTextInputControl.invalid,
                        'is-valid': dropdownTextInputControl.valid,
                    }"
                    paceCoreTextInputRestriction
                />
            }
            @if (model.options.scannable) {
                <button class="btn btn-secondary" type="button" (click)="doScan()">
                    <fa-icon [icon]="faBarcode" size="2x"></fa-icon>
                </button>
            }
            @if (model.value.length > 0) {
                <div class="d-flex" (click)="toggleDropdownFromMenu($event)">
                    <fa-icon [icon]="faCaretDown" class="input-group-text"></fa-icon>
                </div>
            }
            <span class="visually-hidden">Toggle Dropdown</span>
        </div>
        @if (model.value.length > 0) {
            <ul class="dropdown-menu" #dropDownMenu role="menu" [ngClass]="{ show: showDropdownMenu }">
                <li role="menuitem">
                    @if (model.value.length > 3) {
                        <input
                            type="text"
                            formControlName="searchInput"
                            (click)="$event.stopPropagation()"
                            class="form-control"
                            [placeholder]="strings.searchPlaceholder"
                        />
                    }
                </li>
                @for (entry of searchMatchingEntries; track entry) {
                    <li role="menuitem">
                        <a
                            class="dropdown-item"
                            (click)="onSelected(entry)"
                            [ngClass]="{ 'highlight-selection': isSelected(entry) }"
                            >{{ entry.displayName }}</a
                        >
                    </li>
                }
            </ul>
        }
    </div>

    @if (model.options.maxSelections > 1 && model.selectedEntries.length > 0) {
        <ul class="tags">
            @for (entry of model.selectedEntries; track entry) {
                <li (click)="onSelected(entry)">
                    {{ entry.displayName }}
                    @if (!model.options.alwaysSelectedEntries.includes(entry.value)) {
                        <span>
                            <fa-icon class="mx-1" [icon]="faTimes"></fa-icon>
                        </span>
                    }
                </li>
            }
        </ul>
    }
</form>
